import { gql } from '@apollo/client';

const GET_USER_FLOW_BY_URL = gql`
  query getUserFlowByUrl($projectId: String!, $url: String!) {
    userFlow {
      getUserFlowByUrl(projectId: $projectId, url: $url) {
        id
        url
        descriptionContentGroup {
          id
          title
          linkedAssets {
            assetId
            fileName
            contentType
            presignedUrl
          }
        }
        userFlowSteps {
          contentGroup {
            iconAsset {
              presignedUrl
            }
            estimatedTime
            linkedAssets {
              title
              presignedUrl
              tagList {
                name
              }
            }
            contentPages(status: [PUBLISHED, UNPUBLISHED], topLevelOnly: true) {
              url
              hasBeenViewed
            }
            sort
          }
          id
          isComplete
          lastViewedContentPageCompletion {
            createdAtUtc
            contentPage{
              url
            }
          }
          lastTracking {
            completedDate
            completedLongDate
          }
          percentageCompleted
          sort
          stepName
          url
        }
      }
    }
  }
`;

export { GET_USER_FLOW_BY_URL };
